import React from "react";
import "./card1.css";
const Card1 = (props) => {
    return (
        <div className="cardbody card1 cardHover" style={{}}>
            <div className="text3">
                <img src={props.icon} alt="ico"></img>
            </div>
            <div className="text1">
                {props.head}
                <div className="text">
                    {props.text}
                </div>
            </div>
        </div>
    )
}
export default Card1;